import React, { createContext, useContext, useState, useCallback } from "react";
import { X, Warning } from "@phosphor-icons/react";

const ConfirmCtx = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState(null); // {title, message, onConfirm, tone}

  const confirm = useCallback(({ title, message, confirmLabel = "Delete", tone = "danger" } = {}) => {
    return new Promise((resolve) => {
      setState({
        title: title || "Are you sure?",
        message: message || "",
        confirmLabel,
        tone,
        onConfirm: () => { setState(null); resolve(true); },
        onCancel: () => { setState(null); resolve(false); },
      });
    });
  }, []);

  return (
    <ConfirmCtx.Provider value={confirm}>
      {children}
      {state && (
        <div className="fixed inset-0 z-[100] bg-black/40 flex items-center justify-center p-4 fade-in" data-testid="confirm-dialog">
          <div className="bg-white rounded-lg border border-neutral-200 w-full max-w-sm shadow-2xl">
            <div className="p-5">
              <div className="flex items-start gap-3">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${state.tone === "danger" ? "bg-red-100 text-red-600" : "bg-amber-100 text-amber-600"}`}>
                  <Warning size={20} weight="fill" />
                </div>
                <div className="flex-1">
                  <div className="font-display font-semibold text-neutral-900">{state.title}</div>
                  {state.message && <div className="text-sm text-neutral-500 mt-1">{state.message}</div>}
                </div>
                <button onClick={state.onCancel} className="p-1 rounded hover:bg-neutral-100 text-neutral-400"><X size={16} /></button>
              </div>
            </div>
            <div className="px-5 py-3 bg-neutral-50 border-t border-neutral-200 flex justify-end gap-2 rounded-b-lg">
              <button data-testid="confirm-cancel" onClick={state.onCancel} className="dos-btn dos-btn-secondary">Cancel</button>
              <button data-testid="confirm-ok" onClick={state.onConfirm} className={`dos-btn ${state.tone === "danger" ? "bg-red-600 text-white hover:bg-red-700 border border-red-600" : "dos-btn-primary"}`}>{state.confirmLabel}</button>
            </div>
          </div>
        </div>
      )}
    </ConfirmCtx.Provider>
  );
}

export const useConfirm = () => useContext(ConfirmCtx);
